import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { dispatchEventWrapper } from '../../modules/event/event';
import { isIos } from '../mobile-detect/mobile-detect';

type Checkout = Awaited<ReturnType<typeof AdyenCheckout>>;
// https://docs.adyen.com/payment-methods/apple-pay/web-component
// https://github.com/Adyen/adyen-web

/*window.threeds2utilities = threeds2utilities;*/
setupAdyen()
//#region CardPayment
function setupCardPayment(checkout: Checkout) {
  const CARD_SELECTOR = document.querySelector('#card-container');
  var enableAdyenStoreCard = (document.querySelector<HTMLInputElement>('input[name=adyenShowStoredCards]')?.value === 'true');
  if (CARD_SELECTOR) {
    const card = checkout
      .create('card', {
        // Optional configuration
        enableStoreDetails: enableAdyenStoreCard,
        hasHolderName: false,
        holderNameRequired: false,
        showStoredPaymentMethods: enableAdyenStoreCard,
        autoFocus: false,
        onChange: (state, component) => {
          console.log(state);
        },
        onSubmit: (state, component) => {
          console.log(state);
          handleCard(state, component, checkout);
          pushTypeToDataLayer(state);
        },
        billingAddressRequired: false, // Optional. Set to true to show the billing address input fields.
        showBrandsUnderCardNumber: false // Optional. Set to true to show the brands under the card number input.
      })
      .mount('#card-container');
  }
}
//#endregion

interface StateType {
  data?: {
    paymentMethod?: {
      type: string;
    };
  };
}

function pushTypeToDataLayer(state: StateType) {
  if (state.data?.paymentMethod) dispatchEventWrapper(document, 'rc-payment-method-selected', state.data.paymentMethod.type);
}

//#region StoredCard
function handleCard(state, component, checkout) {
  const CUSTOMER_GUID = document.querySelector<HTMLInputElement>('#customer-guid').value;

  const ORDER_TOTAL = document.querySelector<HTMLInputElement>('#orderTotal').value;

  let formData = new FormData();
  formData.append('value', ORDER_TOTAL);
  formData.append('number', state.data.paymentMethod.encryptedCardNumber);
  formData.append('month', state.data.paymentMethod.encryptedExpiryMonth);
  formData.append('year', state.data.paymentMethod.encryptedExpiryYear);
  formData.append('cv2', state.data.paymentMethod.encryptedSecurityCode);
  formData.append('storeDetails', state.data.storePaymentMethod);

  const url = `/securecheckout/card/Request/${CUSTOMER_GUID}`;

  return fetch(url, {
    method: 'POST',
    body: formData
  })
    .then((response) => response.json())
    .then((data) => handleCardData(data, checkout))
    .then(showFinalResult)
    .catch(logAndThrow);

  function handleCardData(data, checkout) {
    if (data.action) {
      checkout.createFromAction(data.action).mount('#my-container');
      return;
    }

    return data;
  }
}

function handleStoredCard(state, component, checkout) {
  const CUSTOMER_GUID = document.querySelector<HTMLInputElement>('#customer-guid').value;
  const THANK_YOU = document.querySelector<HTMLDivElement>('#thankyouLoadingPage');

  THANK_YOU.classList.remove('ninja');
  const ORDER_TOTAL = document.querySelector<HTMLInputElement>('#orderTotal').value;

  let formData = new FormData();
  formData.append('value', ORDER_TOTAL);

  formData.append('customerCardTokenId', state.data.paymentMethod.storedPaymentMethodId);

  const url = `/securecheckout/card/RequestToken/${CUSTOMER_GUID}`;

  return fetch(url, {
    method: 'POST',
    body: formData
  })
    .then((response) => response.json())
    .then((data) => handleStoredCardData(data, checkout))
    .then(showFinalResult)
    .catch(logAndThrow);

  function handleStoredCardData(data, checkout) {
    if (data.action) {
      checkout.createFromAction(data.action).mount('#my-container');
      return;
    }
    return data;
  }
}
//#endregion StoredCard

//#region Clearpay
function setupClearPay(checkout, options) {
  const CLEARPAY_SELECTOR = document.querySelector('#clearpay-container');

  if (!CLEARPAY_SELECTOR) return;

  const clearpayComponent = checkout
    .create('clearpay', {
      onSubmit: handleClearPayOnSubmit
    })
    .mount('#clearpay-container');

  function handleClearPayOnSubmit(state, component) {
    const THANK_YOU = document.querySelector('#thankyouLoadingPage');
    const ORDER_TOTAL = document.querySelector<HTMLInputElement>('#orderTotal').value;
    const CUSTOMER_GUID = document.querySelector<HTMLInputElement>('#customer-guid').value;
    THANK_YOU.classList.remove('ninja');

    let formData = new FormData();
    formData.append('clearPayToken', JSON.stringify(state.data));
    formData.append('value', ORDER_TOTAL);

    const url = `/checkout/clearpay/Request/${CUSTOMER_GUID}`;

    return fetch(url, {
      method: 'POST',
      body: formData
    })
      .then((response) => response.json())
      .then((data) => handleClearPayData(data, checkout))
      .then(showFinalResult)
      .catch(logAndThrow);
  }
}

function handleClearPayData(data, checkout) {
  if (data.action) {
    checkout.createFromAction(data.action).mount('#my-container');
    return;
  }

  return data;
}

//#endregion

//#region ApplePay
function setupApplePay(checkout, options) {
  const APPLE_PAY_SELECTOR = '#apple-pay-container';
  const APPLE_PAY_PANEL = document.querySelector('#apple-pay-panel');

  const APPLE_PAY_BASKET_SELECTOR = '#apple-pay-basket-container';
  const APPLE_PAY_BASKET_PANEL = document.querySelector('#apple-pay-basket-panel');

  //let token = "";
  let _state;
  let mountContainer;
  let mountSelector;
  let applePay;

  const baseOptions = {
    amount: {
      currency: options.orderCurrency,
      value: parseFloat(options.orderTotal)
    },
    countryCode: options.countryCode,
    // Button config
    // Optional. The type of button you want to be displayed in the payments form
    buttonType: 'buy',
    // Optional. Specify the color of the button
    buttonColor: 'black',
    onChange: (state, component) => {
      //token = state.data.paymentMethod.applePayToken;
      _state = state;
    }
  };

  if (APPLE_PAY_PANEL) {
    mountSelector = APPLE_PAY_SELECTOR;
    mountContainer = APPLE_PAY_PANEL;

    applePay = checkout.create('applepay', {
      ...baseOptions,
      onAuthorized: (resolve, reject, appleEvent) => {
        handleApplePayment(
          {
            ...options,
            isBasket: false
          },
          checkout,
          _state,
          appleEvent
        );
      }
    });
  }

  if (APPLE_PAY_BASKET_PANEL) {
    mountSelector = APPLE_PAY_BASKET_SELECTOR;
    mountContainer = APPLE_PAY_BASKET_PANEL;

    applePay = checkout.create('applepay', {
      ...baseOptions,
      requiredShippingContactFields: ['postalAddress', 'name', 'email'],
      onAuthorized: (resolve, reject, appleEvent) => {
        handleApplePayment(
          {
            ...options,
            isBasket: true
          },
          checkout,
          _state,
          appleEvent
        );
      }
    });
  }
  if (APPLE_PAY_PANEL || APPLE_PAY_BASKET_PANEL) {
    applePay
      .isAvailable()
      .then(() => {
        applePay.mount(mountSelector);
      })
      .catch((e) => {
        mountContainer.classList.add('d-none');

        console.log('Apple pay not available');
        console.log(e);
      });
  }
}

function handleAppleData(data, checkout) {
  if (data.action) {
    checkout.createFromAction(data.action).mount('#my-container');
    return;
  }

  return data;
}

async function handleApplePayment(options, checkout, state, appleEvent) {
  const THANK_YOU = document.querySelector('#thankyouLoadingPage');

  THANK_YOU.classList.remove('ninja');

  const { customerGuid, orderTotal, isBasket } = options;
  const token = state.data.paymentMethod.applePayToken;

  let formData = new FormData();
  formData.append('applePayToken', token);
  formData.append('value', orderTotal);

  if (isBasket) {
    formData.append('email', appleEvent.payment.shippingContact.emailAddress);
    for (let i = 0; i < 3 && i < appleEvent.payment.shippingContact.addressLines.length; i++) {
      formData.append('address' + (i + 1), appleEvent.payment.shippingContact.addressLines[i]);
    }
    formData.append('countryCode', appleEvent.payment.shippingContact.countryCode);
    formData.append('locality', appleEvent.payment.shippingContact.locality);
    formData.append('postalCode', appleEvent.payment.shippingContact.postalCode);
    formData.append('name', appleEvent.payment.shippingContact.givenName + ' ' + appleEvent.payment.shippingContact.familyName);
  }

  const url = isBasket ? `/securecheckout/applepay/BasketRequest/${customerGuid}` : `/securecheckout/applepay/Request/${customerGuid}`;

  return fetch(url, {
    method: 'POST',
    body: formData
  })
    .then((response) => response.json())
    .then((data) => handleAppleData(data, checkout))
    .then(showFinalResult)
    .catch(logAndThrow);
}

//#endregion
//#region GooglePay

function setupGooglePay(checkout, options) {
  const GOOGLE_PAY_SELECTOR = '#google-pay-container';
  const GOOGLE_PAY_PANEL = document.querySelector('#google-pay-panel');
  const GOOGLE_PAY_BASKET_SELECTOR = '#google-pay-basket-container';
  const GOOGLE_PAY_BASKET_PANEL = document.querySelector('#google-pay-basket-panel');
  const GOOGLE_PAY_ENVIRONMENT = document.querySelector<HTMLInputElement>('#google-pay-environment')?.value;

  let mountContainer;
  let mountSelector;
  let googlePay;

  const baseOptions = {
    environment: GOOGLE_PAY_ENVIRONMENT, //Change this to PRODUCTION when you're ready to accept live Google Pay payments.
    amount: {
      currency: options.orderCurrency,
      value: options.orderTotal
    },
    configuration: {
      gatewayMerchantId: options.adyenMerchantId, //Your Adyen merchant or company account name.
      merchantName: options.adyenMerchantName, //Optional. The name that appears in the payment sheet.
      merchantId: options.googleMerchantId
    },
    buttonColor: 'black',
    buttonSizeMode: 'fill'
  };

  if (GOOGLE_PAY_PANEL) {
    mountContainer = GOOGLE_PAY_PANEL;
    mountSelector = GOOGLE_PAY_SELECTOR;

    googlePay = checkout.create('paywithgoogle', {
      ...baseOptions,
      onClick: (resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/securecheckout/googlepay/createusersnapshot', false);
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.onload = function () {
          // do something to response
          var json = JSON.parse(this.responseText);
          if (json.success) {
            resolve();
          } else {
            reject();
          }
        };
        xhr.send();

        //handleGooglePayClick(resolve, reject, false);
      },
      onAuthorized: (state, component) => {
        handleGoogleOnAuthorization(
          {
            ...options,
            isBasket: false
          },
          checkout,
          state
        );
      }
    });
  }

  if (GOOGLE_PAY_BASKET_PANEL) {
    mountContainer = GOOGLE_PAY_BASKET_PANEL;
    mountSelector = GOOGLE_PAY_BASKET_SELECTOR;

    googlePay = checkout.create('paywithgoogle', {
      ...baseOptions,
      shippingAddressRequired: true,
      billingAddressRequired: true,
      emailRequired: true,
      onClick: (resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/securecheckout/googlepay/createusersnapshot', false);
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.onload = function () {
          // do something to response
          var json = JSON.parse(this.responseText);
          if (json.success) {
            resolve();
          } else {
            reject();
          }
        };
        xhr.send();
        //handleGooglePayClick(resolve, reject, true);
      },
      onAuthorized: (state, component) => {
        handleGoogleOnAuthorization(
          {
            ...options,
            isBasket: true
          },
          checkout,
          state
        );
      }
    });
  }

  if (GOOGLE_PAY_PANEL || GOOGLE_PAY_BASKET_PANEL) {
    googlePay
      .isAvailable()
      .then(() => {
        googlePay.mount(mountSelector);
      })
      .catch((e) => {
        //Google Pay is not available
        mountContainer.classList.add('d-none');
        console.log(e);
      });
  }
}

async function handleGoogleOnAuthorization(options, checkout, state) {
  const THANK_YOU = document.querySelector('#thankyouLoadingPage');
  const { customerGuid, orderTotal, isBasket } = options;
  const token = state.paymentMethodData.tokenizationData.token;

  THANK_YOU.classList.remove('ninja');

  let formData = new FormData();
  formData.append('googlePayToken', token);
  formData.append('value', orderTotal);

  if (isBasket) {
    formData.append('email', state.email);
    formData.append('address1', state.shippingAddress.address1);
    formData.append('address2', state.shippingAddress.address2);
    formData.append('address3', state.shippingAddress.address3);
    formData.append('countryCode', state.shippingAddress.countryCode);
    formData.append('locality', state.shippingAddress.locality);
    formData.append('postalCode', state.shippingAddress.postalCode);
    formData.append('name', state.paymentMethodData.info.billingAddress.name);
    formData.append('phoneNumber', state.shippingAddress.phoneNumber);
  }

  const url = isBasket ? `/securecheckout/googlepay/BasketRequest/${customerGuid}` : `/securecheckout/googlepay/Request/${customerGuid}`;

  return fetch(url, {
    method: 'POST',
    body: formData
  })
    .then((response) => response.json())
    .then((data) => handleGoogleData(data, checkout))
    .then(showFinalResult)
    .catch(logAndThrow);
}

function handleGoogleData(data, checkout) {
  if (data.action) {
    checkout.createFromAction(data.action).mount('#google-pay-basket-container');
    return;
  }

  return data;
}

function handleGooglePayClick(resolve, reject, isBasket) {
  const url = isBasket ? '/securecheckout/googlepay/createusersnapshot' : '/securecheckout/googlepay/createorder';

  return fetch(url, {
    method: 'POST'
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        resolve();
        return;
      }

      reject();
    })
    .catch(console.log);
}
//#endregion

//#region Amazon Pay
function setupAmazonPay(checkout, options) {
  const AMAZON_PAY_SELECTOR = '#amazon-pay-container';
  const AMAZON_PAY_PANEL = document.querySelector('#amazon-pay-panel');

  const AMAZON_PAY_BASKET_SELECTOR = '#amazon-pay-basket-container';
  const AMAZON_PAY_BASKET_PANEL = document.querySelector('#amazon-pay-basket-panel');
  const AMAZON_PAY_DETAILS_PANEL = document.querySelector('#amazon-pay-details-container');
  const AMAZON_PAY_PAYMENT_PANEL = document.querySelector('#amazon-pay-payment-container');
  const AMAZON_PAY_CONFIRMATION_PANEL = document.querySelector('#amazon-pay-confirmation-container');

  // Panels output in the View - these control if a payment is turned on
  const AMAZON_PAY_MERCHANT_ID = document.querySelector<HTMLInputElement>('#amazon-pay-merchant-id')?.value;
  const AMAZON_PAY_PUBLIC_KEY_ID = document.querySelector<HTMLInputElement>('#amazon-pay-public-key-id')?.value;
  const AMAZON_PAY_REDIRECT_URL = document.querySelector<HTMLInputElement>('#amazon-pay-redirect-url')?.value;
  const AMAZON_PAY_ENVIRONMENT = document.querySelector<HTMLInputElement>('#amazon-pay-environment')?.value;
  const AMAZON_PAY_STORE_ID = document.querySelector<HTMLInputElement>('#amazon-pay-store-id')?.value;
  const AMAZON_PAY_SESSION_ID = document.querySelector<HTMLInputElement>('#amazon-pay-session-id')?.value;
  const WEBSITE_URL = document.querySelector<HTMLInputElement>('#website-url')?.value;

  let mountContainer;
  let mountSelector;
  let amazonPay;
  let amazonPayOrder;

  if (AMAZON_PAY_PANEL) {
    mountContainer = AMAZON_PAY_PANEL;
    mountSelector = AMAZON_PAY_SELECTOR;
  }

  if (AMAZON_PAY_BASKET_PANEL) {
    mountContainer = AMAZON_PAY_BASKET_PANEL;
    mountSelector = AMAZON_PAY_BASKET_SELECTOR;

    amazonPayOrder = checkout
      .create('amazonpay', {
        // Returned in the `/paymentMethods` response
        configuration: {
          merchantId: AMAZON_PAY_MERCHANT_ID,
          publicKeyId: AMAZON_PAY_PUBLIC_KEY_ID,
          storeId: AMAZON_PAY_STORE_ID
        },
        currency: options.orderCurrency,
        environment: AMAZON_PAY_ENVIRONMENT,
        returnUrl: WEBSITE_URL + '/checkout/amazonPay',
        deliverySpecifications: {
          addressRestrictions: {
            type: 'Allowed',
            restrictions: {
              GB: {}
            }
          }
        }
      })
      .mount('#amazon-pay-basket-container');
  }

  if (AMAZON_PAY_DETAILS_PANEL) {
    mountContainer = AMAZON_PAY_BASKET_PANEL;
    mountSelector = AMAZON_PAY_BASKET_SELECTOR;

    const amazonPayComponent = checkout
      .create('amazonpay', {
        // Returned in the `/paymentMethods` response
        configuration: {
          merchantId: AMAZON_PAY_MERCHANT_ID,
          publicKeyId: AMAZON_PAY_PUBLIC_KEY_ID,
          storeId: AMAZON_PAY_STORE_ID
        },
        currency: options.orderCurrency,
        environment: AMAZON_PAY_ENVIRONMENT,
        amount: {
          currency: options.orderCurrency,
          value: options.orderTotal
        },
        showChangePaymentDetailsButton: true, // Optional,
        showOrderButton: false,
        amazonCheckoutSessionId: AMAZON_PAY_SESSION_ID,
        deliverySpecifications: {
          addressRestrictions: {
            type: 'Allowed',
            restrictions: {
              GB: {}
            }
          }
        }
      })
      .mount('#amazon-pay-details-container');

    amazonPayComponent.getShopperDetails().then((details) => {
      // Show shopper details
      document.querySelector<HTMLSelectElement>('#ddlTitle').value = 'Mx';
      document.querySelector<HTMLSelectElement>('#ddlTitle')?.click();

      document.querySelector<HTMLInputElement>('#txtFirstname').value = details.shippingAddress.name.split(' ')[0];
      document.querySelector<HTMLInputElement>('#txtLastname').value = details.shippingAddress.name.split(' ')[1];
      document.querySelector<HTMLInputElement>('#txtPhone').value = details.buyer.phoneNumber;
      document.querySelector<HTMLInputElement>('#txtEmail').value = details.buyer.email;

      document.querySelector<HTMLInputElement>('#txtLine1Billing').value = details.billingAddress.addressLine1;
      document.querySelector<HTMLInputElement>('#txtLine2Billing').value = details.billingAddress.addressLine2;
      document.querySelector<HTMLInputElement>('#txtPostcodeBilling').value = details.billingAddress.postalCode;
      document.querySelector<HTMLInputElement>('#txtTownBilling').value = details.billingAddress.city;
      document.querySelector<HTMLInputElement>('#txtCountyBilling').value = details.billingAddress.county;

      var countryCode = getCountryCode(details.billingAddress.countryCode);

      document.querySelector<HTMLInputElement>('#ddlCountryBilling').value = getCountryCode(details.billingAddress.countryCode).toString();

      document.querySelector<HTMLInputElement>('#txtLine1Delivery').value = details.shippingAddress.addressLine1;
      document.querySelector<HTMLInputElement>('#txtLine2Delivery').value = details.shippingAddress.addressLine2;
      document.querySelector<HTMLInputElement>('#txtPostcodeDelivery').value = details.shippingAddress.postalCode;
      document.querySelector<HTMLInputElement>('#txtTownDelivery').value = details.shippingAddress.city;
      document.querySelector<HTMLInputElement>('#txtCountyDelivery').value = details.shippingAddress.county;
      document.querySelector<HTMLInputElement>('#ddlCountryDelivery').value = getCountryCode(details.shippingAddress.countryCode).toString();

      const billindAddressLookupContainer = document.querySelector('.js-billing-address');
      if (billindAddressLookupContainer) {
        billindAddressLookupContainer.querySelector<HTMLInputElement>('.js-use-address')?.click();
      }

      document.querySelector<HTMLInputElement>('#checkboxDeliverySame')?.click();

      const deliveryAddressLookupContainer = document.querySelector('.js-delivery-address');
      if (deliveryAddressLookupContainer) {
        deliveryAddressLookupContainer.querySelector<HTMLInputElement>('.js-use-address')?.click();
      }
    });
  }

  if (AMAZON_PAY_PAYMENT_PANEL) {
    mountContainer = AMAZON_PAY_BASKET_PANEL;
    mountSelector = AMAZON_PAY_BASKET_SELECTOR;

    const amazonPayComponent = checkout
      .create('amazonpay', {
        configuration: {
          merchantId: AMAZON_PAY_MERCHANT_ID,
          publicKeyId: AMAZON_PAY_PUBLIC_KEY_ID,
          storeId: AMAZON_PAY_STORE_ID
        },
        currency: options.orderCurrency,
        environment: AMAZON_PAY_ENVIRONMENT,
        returnUrl: WEBSITE_URL + '/checkout/amazonpay/createorder',
        amount: {
          currency: options.orderCurrency,
          value: options.orderTotal
        },
        showChangePaymentDetailsButton: true, // Optional,
        showOrderButton: true,
        amazonCheckoutSessionId: AMAZON_PAY_SESSION_ID,
        buttonColor: 'Gold'
      })
      .mount('#amazon-pay-payment-container');
  }
  if (AMAZON_PAY_CONFIRMATION_PANEL) {
    const THANK_YOU = document.querySelector('#thankyouLoadingPage');
    const ORDER_TOTAL = document.querySelector<HTMLInputElement>('#orderTotal').value;
    const CUSTOMER_GUID = document.querySelector<HTMLInputElement>('#customer-guid').value;

    const amazonPayComponent = checkout
      .create('amazonpay', {
        amazonCheckoutSessionId: AMAZON_PAY_SESSION_ID,
        showOrderButton: false,
        onSubmit: async (state, component) => {
          component.setStatus('loading');

          const token = state.data.paymentMethod.checkoutSessionId;

          let formData = new FormData();
          formData.append('amazonPayToken', token);
          formData.append('value', ORDER_TOTAL);

          const url = '/checkout/amazonpay/Request/' + CUSTOMER_GUID;

          var data = await fetch(url, {
            method: 'POST',
            body: formData
          }).then((response) => response.json());

          var success = data.success;

          console.log(data);

          if (data.action) {
            THANK_YOU.classList.add('ninja');
            checkout.createFromAction(data.action).mount('#my-container');
            return;
          }

          alert(data.error);

          if (success) {
            window.location.href = data.redirectUrl;
          } else if (data.error === 'Refused') {
            // Handle decline flow
            THANK_YOU.classList.add('ninja');
            amazonPayComponent.handleDeclineFlow();
          } else {
            // Handle decline flow
            THANK_YOU.classList.add('ninja');
            window.location.href = '/basket?error=Your order was rejected by Amazon, please try again';
          }
        }
      })
      .mount('#amazon-pay-confirmation-container');

    amazonPayComponent.submit();
  }
}
//#endregion

function getCountryCode(code: string) {
  switch (code) {
    case 'GB':
      return 1;
    case 'IE':
      return 2;
    case 'FR':
      return 3;
    case 'DE':
      return 4;
    case 'US':
      return 10;
    case 'IT':
      return 15;
    case 'ES':
      return 19;
  }
}

export function destroyAdyen() {
  const containers = document.querySelectorAll('#stored-card, #card-container, #apple-pay-container, #apple-pay-basket-container, #google-pay-container, #google-pay-basket-container, #amazon-pay-basket-container');
  containers.forEach((c) => (c.innerHTML = ''));
}
export function destroySpecificAdyen(container) {
  const containers = document.querySelectorAll(container);
  containers.forEach((c) => (c.innerHTML = ''));
}

export async function setupAdyen() {
  // Key information about this integration, all controlled by hidden inputs on the page
  const IS_BASKET = document.querySelector<HTMLInputElement>('#isBasket')?.value === 'true';
  const ADYEN_KEY = document.querySelector<HTMLInputElement>('#adyen-client-key')?.value;
  const ADYEN_ENVIRONMENT = document.querySelector<HTMLInputElement>('#adyen-environment')?.value;
  const ADYEN_LOCALE = document.querySelector<HTMLInputElement>('#adyen-locale')?.value;
  const ADYEN_MERCHANT_ID = document.querySelector<HTMLInputElement>('#adyen-merchant-name')?.value;

  const CUSTOMER_GUID = document.querySelector<HTMLInputElement>('#customer-guid')?.value;
  const ORDER_TOTAL = document.querySelector<HTMLInputElement>('#orderTotal')?.value;
  const ORDER_CURRENCY = document.querySelector<HTMLInputElement>('#currency')?.value;
  const COUNTRY_CODE = document.querySelector<HTMLInputElement>('#country-code')?.value;
  const GOOGLE_MERCHANT_ID = document.querySelector<HTMLInputElement>('#google-merchant-id')?.value;

  let configuration = {
    locale: ADYEN_LOCALE,
    environment: ADYEN_ENVIRONMENT,
    clientKey: ADYEN_KEY,
    paymentMethodsResponse: window.adyenPaymentsMethod,
    onChange: handleOnChange,
    onAdditionalDetails: handleOnAdditionalDetails,
    showPayButton: true,
    amount: {
      value: parseFloat(ORDER_TOTAL),
      currency: ORDER_CURRENCY
    },
  };


  const checkout: Checkout = await AdyenCheckout(configuration);

  var storedPaymentMethods = (checkout as any).paymentMethodsResponse.storedPaymentMethods;

  if (!IS_BASKET && storedPaymentMethods && storedPaymentMethods.length > 0) {
    document.querySelector('.js-saved-cards').classList.remove('d-none');
    let dropdown = document.getElementById('stored-cards') as HTMLSelectElement;
    let defaultOption = document.createElement('option');
    dropdown.length = 0;
    defaultOption.text = 'Choose Card';
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;
    for (var i = 0; i < storedPaymentMethods.length; i++) {
      var option = document.createElement('option');
      option.text = '************' + storedPaymentMethods[i].lastFour;
      option.value = storedPaymentMethods[i].id;
      dropdown.add(option);
    }
    var e = document.getElementById('stored-cards');
    e.onchange = function () {
      changeCard(e, checkout);
    };
  }

  setupCardPayment(checkout);
  if (isIos()) {
    setupApplePay(checkout, {
      orderCurrency: ORDER_CURRENCY,
      countryCode: COUNTRY_CODE,
      orderTotal: ORDER_TOTAL,
      customerGuid: CUSTOMER_GUID
    });
  } else {
    setupGooglePay(checkout, {
      orderCurrency: ORDER_CURRENCY,
      countryCode: COUNTRY_CODE,
      orderTotal: ORDER_TOTAL,
      customerGuid: CUSTOMER_GUID,
      adyenMerchantId: ADYEN_MERCHANT_ID,
      adyenMerchantName: 'MossBros',
      googleMerchantId: GOOGLE_MERCHANT_ID
    });
  }

  setupAmazonPay(checkout, {
    orderCurrency: ORDER_CURRENCY,
    countryCode: COUNTRY_CODE,
    orderTotal: ORDER_TOTAL,
    customerGuid: CUSTOMER_GUID
  });

  setupClearPay(checkout, {
    orderCurrency: ORDER_CURRENCY,
    countryCode: COUNTRY_CODE,
    orderTotal: ORDER_TOTAL,
    customerGuid: CUSTOMER_GUID
  });

  function handleOnAdditionalDetails(state, component) {
    fetch('/securecheckout/adyen/details', {
      method: 'POST',
      body: JSON.stringify(state.data),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('additionDetails', data);
      })
      .catch((e) => console.log(e));

    console.log(
      state.data, // Provides the data that you need to pass in the `/payments/details` call.
      component // Provides the active component instance that called this event.
    );
  }
}

function handleOnChange(state, component) {
  console.log(
    'handleOnChange',
    state.isValid, // True or false. Specifies if all the information that the shopper provided is valid.
    state.data, // Provides the data that you need to pass in the `/payments` call.
    component // Provides the active component instance that called this event.
  );

  if (!state.isValid) {
    console.log('Adyen state not valid yet');
    return;
  }
}
// Calls your server endpoints
async function callServer(url, data) {
  const res = await fetch(url, {
    method: 'POST',
    body: data ? JSON.stringify(data) : '',
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return await res.json();
}
function filterUnimplemented(pm) {
  pm.paymentMethods = pm.paymentMethods?.filter((it) => ['clearpay', 'ideal', 'applepay', 'card', 'scheme', 'zip', 'giropay', 'directEbanking'].includes(it.type));
  return pm;
}

function changeCard(e, checkout: Awaited<ReturnType<typeof AdyenCheckout>>) {
  var selectedCardId = e.options[e.selectedIndex].value;
  var selectedCard = findId(checkout.paymentMethodsResponse.storedPaymentMethods, selectedCardId);
  if (selectedCard != undefined) {
    let configuration = {
      ...selectedCard,
      onSubmit: (state, component) => {
        event.preventDefault();
        console.log("state", state);
        handleStoredCard(state, component, checkout);
        pushTypeToDataLayer(state.data.paymentMethod);
      }
    };
    const card = checkout.create("card", configuration).mount("#stored-card");
    document.getElementById('card-container').classList.add('d-none');
    document.getElementById('stored-card').classList.remove('d-none');
  } else {
    document.getElementById('card-container').classList.remove('d-none');
    document.getElementById('stored-card').classList.add('d-none');
  }
}
function findId(data, idToLookFor) {
  var categoryArray = data;
  for (var i = 0; i < categoryArray.length; i++) {
    if (categoryArray[i].id == idToLookFor) {
      return categoryArray[i];
    }
  }
}
function logAndThrow(error) {
  throw Error(error);
}

function showFinalResult(response) {
  if (response.redirectUrl) window.location.href = response.redirectUrl;
  else throw response.error + ' : ' + response.errorMessage;
}
